<template>
  <div class="index-page">
    <TopNav home/>

    <el-carousel trigger="click" height="42vw" class="sider">
      <el-carousel-item v-for="(item, key) in sideList" :key="key" class="carousel-item">
        <div class="carousel-item-in">
          <a :href="item.redirect_url" v-if="item.redirect_url != '#'" target="_blank"><img :src="item.src"></a>
          <img :src="item.src" v-else>
          <h3>{{item.title}}</h3>
          <p>{{item.text}}</p>
        </div>
      </el-carousel-item>
    </el-carousel>

    <section class="intro-section">
      <div class="intro-in">
        <div class="intro-head">
          <figure class="intro-head-fig">
            <img :src="des.intro_img" style="width: 570px;height: auto;" class="intro-head-img">
          </figure>
          <div class="intro-head-main">
            <h3 class="intro-head-title">{{des.intro_title}}</h3>
            <div class="intro-head-content" v-html="des.intro_cont" id="vDom"></div>
          </div>
        </div>

        <!--<ul class="intro-list">
          <li class="intro-item">
            <h3 class="intro-item-title">平台理念</h3>
            <div class="intro-item-content">
              以建构主义的教育理念为基础，关注学员的改变，关注学员的体验，关注学员的成长；授之以欲，受之以愉，渔之以渔。
            </div>
          </li>

          <li class="intro-item">
            <h3 class="intro-item-title">平台价值</h3>
            <div class="intro-item-content">
              让中小企业在发展及转型的过程中，通过员工随时随地的学习，全面提升其职业化能力，助力企业组建人才梯队，打造自己的核心竞争力。
            </div>
          </li>

          <li class="intro-item">
            <h3 class="intro-item-title">平台愿景</h3>
            <div class="intro-item-content">
              打造一流的企业在线学习平台，成为企业发展转型的坚实伙伴！
            </div>
          </li>
        </ul>-->
      </div>
    </section>
    <!-- 顶典商学院增加的模块 -->
    <section class="idea-section dingdian_set" v-if="dingdian_video.video_url">
      <div class="idea-in">
        <h3 class="idea-head">定制课程项目介绍</h3>
        <video class="video_dingdian" :src="dingdian_video.video_url" :poster="dingdian_video.img_url" controls="controls" width="100%" height="100%" controlslist="nodownload"></video>

      </div>
    </section>

    <!-- 视频 -->
    <section class="idea-section">
      <div class="idea-in">
        <h3 class="idea-head">{{moduleCon.video.title}}</h3>
        <ul class="idea-list">
          <li class="idea-item idea-items" v-for="(item, index) in moduleCon.video.content">
            <video :src="item.video_url" controls="controls" controlslist="nodownload" :poster="item.video_img" width="100%" height="100%"></video>
          </li>
        </ul>
      </div>
    </section>
    <!-- 理念 -->
    <section class="idea-section" style="padding-top:0px">
      <div class="idea-in">
        <h3 class="idea-head">{{moduleCon.design.title}}</h3>
        <ul class="idea-list">
          <li class="idea-item" v-for="item in moduleCon.design.content">
            <img :src="item.img_url">
            <h4 class="idea-title">{{item.title}}</h4>
            <div class="idea-content" :title="item.cont">{{item.cont}}</div>
          </li>
          <!-- <li class="idea-item">
            <img src="./assets/idea2.png">
            <h4 class="idea-title">课程全面实用</h4>
            <div class="idea-content">产、销、人、财、研等部门各岗位各维度的课程，包括专业技能类、通用管理类、职业素养类课程，解决员工的实际工作问题。</div>
          </li>
          <li class="idea-item">
            <img src="./assets/idea3.png">
            <h4 class="idea-title">知识转化落地</h4>
            <div class="idea-content">关注学习效率，对学习效果负责，运用531学习落地模式（5个知识点提炼+3个工作运用+1个改进点），促进知识转化。</div>
          </li> -->
        </ul>
      </div>
    </section>

    <section class="system-section">
      <div class="system-in">
        <h3 class="system-head">{{moduleCon.course.title}}</h3>
        <!--<div class="system-summary">
          <p>为了全方位提升中小企业员工的职业素养、专业技能、软技能等相关职业能力，平台通过大量调研，</p>
          <p>分析出适合中小企业员工的课程体系，所有课程均为视频，课程体系如下：</p>
        </div>-->
        <ul class="system-list">
          <li class="system-item" v-for="item in moduleCon.course.content">
            <div>
              <h4 class="system-title">{{item.title}}</h4>
              <div class="system-des">
                <p v-for="items in item.cate_child">{{items}}</p>
                <!-- <p>商业模式</p>
                <p>战略规划</p>
                <p>运营管理</p>
                <p>转型升级......</p> -->
              </div>
            </div>
          </li>
          <!-- <li class="system-item">
            <div>
              <h4 class="system-title">通用管理类课程</h4>
              <div class="system-des">
                <p>领导力</p>
                <p>团队管理</p>
                <p>目标计划</p>
                <p>沟通协调</p>
                <p>时间管理</p>
                <p>执行力......</p>
              </div>
            </div>
          </li>
          <li class="system-item">
            <div>
              <h4 class="system-title">专业技能类课程</h4>
              <div class="system-des">
                <p>人力资源</p>
                <p>营销销售</p>
                <p>产品研发</p>
                <p>财税审计</p>
                <p>生产制造</p>
                <p>办公软件......</p>
              </div>
            </div>
          </li>
          <li class="system-item">
            <div>
              <h4 class="system-title">个人素养类课程</h4>
              <div class="system-des">
                <p>职业规划</p>
                <p>演讲表达</p>
                <p>社交礼仪</p>
                <p>形象管理</p>
                <p>阳光心态</p>
                <p>情绪压力......</p>
              </div>
            </div>
          </li>
          <li class="system-item">
            <div>
              <h4 class="system-title">企业定制课程</h4>
              <div class="system-des">
                <p>......</p>
              </div>
            </div>
          </li> -->
        </ul>
      </div>
    </section>

    <!--<section class="course-section">
      <div class="course-in">
        <h3 class="course-head">部分视频课程展示</h3>
        <ul class="course-list">
          <li v-for="i in 12" :key="i" class="course-item">
            <a class="course-link">
              <img src="./assets/course1.png" v-if="i == 1">
              <img src="./assets/course2.png" v-if="i == 2">
              <img src="./assets/course3.png" v-if="i == 3">
              <img src="./assets/course4.png" v-if="i == 4">

              <img src="./assets/course5.png" v-if="i == 5">
              <img src="./assets/course6.png" v-if="i == 6">
              <img src="./assets/course7.png" v-if="i == 7">
              <img src="./assets/course8.png" v-if="i == 8">

              <img src="./assets/course9.png" v-if="i == 9">
              <img src="./assets/course10.png" v-if="i == 10">
              <img src="./assets/course11.png" v-if="i == 11">
              <img src="./assets/course12.png" v-if="i == 12">
            </a>
          </li>
        </ul>
      </div>
    </section>-->

    <section class="feature-section">
      <div class="feature-in">
        <h3 class="feature-head">{{moduleCon.feature.title}}</h3>
        <ul class="feature-list">
          <li class="feature-item" v-for="item in moduleCon.feature.content">
            <h4 class="feature-title">{{item.title}}</h4>
            <div class="feature-content">{{item.cont}}</div>
          </li>
          <!-- <li class="feature-item">
            <h4 class="feature-title">热点访谈</h4>
            <div class="feature-content">为了让学员开拓视野，了解最新趋势，平台特设置了“热点访谈”模块，以短视频为呈现方式，邀请各领域大咖、专家、学者等解读时事热点，在平台学习经典课程的同时，还能与未来同行！</div>
          </li>
          <li class="feature-item">
            <h4 class="feature-title">职场充电</h4>
            <div class="feature-content">课程是经典、访谈是未来，那么“职场充电”是学员补充能量的站台。以原创文章为呈现方式，邀请各领域大咖、在职高管等实战派专家，针对职场发展、专业技能、软技能提升等，给出自己的建议，帮助员工实现自我提升！</div>
          </li> -->
        </ul>
      </div>
    </section>

    <!-- 顶典商学院增加的模块 -->
    <section class="idea-section dingdian_ad_p" v-if="college_ad">
      <div class="idea-in-dingdian">
        <img :src="college_ad" width="100%" height="100%" class="dingdian_ad">
      </div>
    </section>

    <!--<div class="contact-section" v-if="tel">
      <span class="contact-tel">客服热线：{{tel}}</span>
    </div>
    <div class="contact-section" v-if="des.isshow_icp">
      <span class="contact-tel"><a class="icp-link" href="http://beian.miit.gov.cn" target="_blank">{{des.isshow_icp}}</a></span>
    </div>-->

    <a :href="`tel:${tel}`" class="tel-fixed" v-if="tel">{{tel}}</a>

    <v-footer></v-footer>
  </div>
</template>

<script>
import mixins from '@/util/mixins'
import Footer from '@/components/Footer'
import TopNav from '@/components/topNav'

export default {
  name: 'index',

  mixins: [mixins],

  components: {
    'v-footer': Footer,
    TopNav,
  },

  data() {
    return {
      videoImg: [require('./assets/video0.jpg'), require('./assets/video1.jpg'), require('./assets/video2.jpg')],
      sideList: [],
      des: {},
      dingdian_video:[],
      college_ad:'',
      moduleCon: {
        video: {
          title: '',
          content: []
        },
        design: { // 设计理念
          title: '',
          content: []
        },
        course: { // 课程体系
          title: '',
          content: []
        },
        feature: { // 特色
          title: '',
          content: []
        },
      }
    }
  },

  async created() {
    // 商学院首页轮播图换成从接口获取
    try {
      const data = await this.ajaxPost('/api/studysys/common/getBannerPcAjax')
      const list = data || []
      this.sideList = list.map(it => ({ src: it.img ,redirect_url: it.redirect_url}))
      // 平台介绍
      let des = await this.ajaxPost('/api/studysys/common/getWebsiteAjax')
      this.des = des
      document.title = des.title
      // 模块内容
      const _module = await this.ajaxPost('/api/studysys/common/getindexstyleAjax')
      // console.log(_module)
      this.moduleCon = _module
      this.dingdian_video = _module.college_video
      this.college_ad = _module.college_ad
    } catch (ex) {
      this.handleError(ex)
    }
  },

  computed: {
    tel() {
      return this.$store.state.tel
    },
    isshow_icp() {
      return this.$store.state.isshow_icp
    }
  },
  updated() {
    let _dom = document.getElementById('vDom')
    let _p = _dom && _dom.getElementsByTagName('P') || []
    for (let i = 0, len = _p.length; i<len; i++) {
      _p[i].setAttribute('style', 'padding-bottom: 30px')
    }
 }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/colors.scss';

.index-page {
  padding-bottom: 48px;
  /deep/ .main-nav-bar {
    background-color: #fff !important;
    height: 80px;
    line-height: 80px;
    .nav-item {
      color: #333 !important;
      line-height: 76px;
      &:hover,
      &:focus {
        color: #f93 !important;
      }
    }
    .nav-logout,
    .nav-login,
    .nav-register,
    .nav-user-name {
      color: #333 !important;
    }
    .nav-item-on {
      color: #f93 !important;
      border-bottom-color: #f93 !important;
    }

    .main-nav .el-submenu__title {
      color: #333 !important;
      line-height: 76px !important;
    }
  }
}

.sider {
  /deep/ .el-carousel__button {
    width: 38px;
    height: 6px;
    opacity: .5;
    background-color: #000;
  }
  /deep/ .is-active .el-carousel__button {
    opacity: 1;
    background-color: #60a3ff;
  }
}

.intro-section {
  background-color: #f2f2f2;
  padding-top: 100px;
  box-sizing: border-box;
}
.icp-link{
color:#fff;
}
.intro-in {
  margin: auto;
  max-width: 1132px;
}

.intro-head {
  display: flex;
}

.intro-head-fig {
  margin: 0;
  // min-width: 570px;
}

.intro-head-img {
  box-shadow: #c2c2c2 30px 30px;
  vertical-align: top;
}

.intro-head-main {
  margin-left: 60px;
  max-width: 502px;
}

.intro-head-title {
  font-size: 30px;
  color: #333;
  line-height: 1;
}

.intro-head-content {
  margin-top: 20px;
  height: 390px;
  overflow-y: auto;
  color: #666;
  font-size: 16px;
  line-height: 30px;
  text-align: justify;
}

.intro-list {
  display: flex;
  margin-top: 79px;
}

.intro-item {
  flex: 1;
  padding: 110px 27px 0;
  text-align: center;
  font-size: 16px;
  line-height: 28px;
  color: #666;
  background: url(./assets/intro2.png) no-repeat center top;
  &:first-child {
    background-image: url(./assets/intro1.png);
  }
  &:last-child {
    background-image: url(./assets/intro3.png);
  }
}

.intro-item-title {
  font-size: 24px;
  color: #333;
}

.intro-item-content {
  margin-top: 22px;
  text-align: left;
}

.idea-section {
  padding: 90px 0 100px;
  background-color: #fff;
}

.idea-in {
  margin: auto;
  max-width: 1132px;
}
.idea-in-dingdian {
  margin: auto;
  max-width: 100%;
}

.idea-head {
  color: #333;
  font-size: 48px;
  text-align: center;
}

.idea-list {
  margin-top: 55px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.idea-item {
  width: calc((100% - 50px) / 3);
  height: 525px;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .1);
  margin-bottom: 10px;
}
.idea-item > video {
  width: 100%;
  height:100%;
  object-fit: fill;
  box-sizing: border-box;
}
.idea-item:nth-of-type(3n - 1) {
  margin: 0 25px;
}
.idea-item > img {
  width: 100%;
  height: auto;
}
.idea-items {
  height: 270px;
}

.idea-title {
  position: relative;
  padding-left: 57px;
  color: #60a3ff;
  font-size: 26px;
  margin-top: 12px;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 30px;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background-color: #60a3ff;
    transform: translateY(-50%);
  }
}

.idea-content {
  color: #666;
  padding: 10px 30px 0;
  font-size: 20px;
  line-height: 36px;
  text-align: justify;
  //background: pink;
  //height: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp:5;
}

.system-section {
  height: 794px;
  background: #222 url(./assets/systemBg.jpg) no-repeat center;
  box-sizing: border-box;
  padding-top: 78px;
}

.system-in {
  margin: auto;
}

.system-head {
  color: #fff;
  font-size: 48px;
  text-align: center;
}

.system-summary {
  font-size: 20px;
  line-height: 36px;
  color: #aaa;
  text-align: center;
  margin-top: 10px;
}

.system-list {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
}

.system-item {
  position: relative;
  flex: 1;
  flex-shrink: 1;
  color: #ccc;
  font-size: 20px;
  // padding: 200px 60px 0;
  padding-top: 200px;
  box-sizing: border-box;
  height: 544px;
  transition: ease-in-out .2s;
  display: flex;
  justify-content: center;
  &::before {
    content: '';
    position: absolute;
    top: 60px;
    left: 50%;
    width: 120px;
    height: 120px;
    margin-left: -60px;
    border-radius: 100%;
    border: 2px solid #fff;
    background: url(./assets/system1.png) no-repeat center;
  }
  &:hover {
    background-color: #0099e4;
    box-shadow: 2px 3px 7px 0 rgba(0, 0, 0, .35);
    transform: translateY(40px);
  }
}

.system-item:nth-child(2)::before {
  background-image: url(./assets/system2.png);
}

.system-item:nth-child(3)::before {
  background-image: url(./assets/system3.png);
}

.system-item:nth-child(4)::before {
  background-image: url(./assets/system4.png);
}

.system-item:nth-child(5)::before {
  background-image: url(./assets/system5.png);
}

.system-title {
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  margin-top: 8px;
  text-align: center;
}

.system-des {
  margin-top: 15px;
  font-size: 19px;
}

.course-section {
  padding: 108px 0 100px;
}

.course-in {
  margin: auto;
}

.course-head {
  color: #333;
  font-size: 48px;
  text-align: center;
}

.course-list {
  max-width: 1200px;
  margin: 20px auto 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.course-item {
  margin-top: 20px;
  width: 25%;
}

.course-link {
  display: block;
  padding: 0 10px;
  > img {
    width: 100%;
    height: auto;
    vertical-align: top;
  }
}

.feature-section {
  padding: 80px 0 100px;
  background-color: #f2f2f2;
}
.feature-in {
  margin: 0 auto;
  max-width: 1200px;
}

.feature-head {
  color: #333;
  font-size: 48px;
  text-align: center;
}

.feature-list {
  display: flex;
  margin: 72px auto 0;
  justify-content: space-between;
}

.feature-item {
  position: relative;
  width: 360px;
  height: 400px;
  background-color: #fff;
  box-shadow: 0 0 25px 0 #f0f0f0;
  font-size: 16px;
  line-height: 27px;
  color: #929292;
  padding: 132px 35px 0;
  border-radius: 6px;
  border-bottom: 8px solid transparent;
  transition: ease-in-out .2s;
  &:nth-of-type(2) {
    margin: 0 15px;
  }
  &::before {
    content: '';
    position: absolute;
    top: 40px;
    left: 50%;
    width: 70px;
    height: 70px;
    border-radius: 100%;
    background: #dfedff url(./assets/feature1.png) no-repeat center;
    transform: translateX(-50%);
  }
  &:hover {
    border-color: #0f7bff;
    transform: translateY(-30px);
  }
}

.feature-item:nth-child(2)::before {
  background-image: url(./assets/feature2.png);
}

.feature-item:nth-child(3)::before {
  background-image: url(./assets/feature3.png);
}

.feature-title {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.feature-content {
  margin-top: 15px;
  text-align: justify;
}

.contact-section {
  color: #fff;
  line-height: 50px;
  text-align: center;
  background-color: #25282b;
}

.contact-address,
.contact-tel {
  display: inline-block;
  font-style: normal;
  margin: 0 25px;
}

.carousel-item-in {
  position: relative;
  height: 100%;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}

.tel-fixed {
  position: fixed;
  top: 30%;
  right: 0;
  width: 139px;
  height: 166px;
  color: #fff;
  background: url(./assets/tel-fixed.png) no-repeat center;
  background-size: cover;
  box-sizing: border-box;
  padding-top: 120px;
  text-align: center;
  z-index: 999;
}
.dingdian_set{
	padding-bottom:0px;
}
.video_dingdian{
padding-top:30px;
}
.dingdian_ad{
padding-bottom:0px;
}
.dingdian_ad_p{
padding-top:0px;
padding-bottom:0px;
line-height:0px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue